import type * as Types from '../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type ActiveEventPersonQueryVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
}>;

export type ActiveEventPersonQuery = {
  __typename?: 'Query';
  activeEventPerson?: { __typename?: 'EventPerson'; id: string; eventId: string; displayName: string; status: Types.EventPersonStatus } | null;
};

export type CreateEventPersonSessionMutationVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
  displayName: Types.Scalars['String'];
}>;

export type CreateEventPersonSessionMutation = {
  __typename?: 'Mutation';
  createEventPersonSession: { __typename?: 'EventPerson'; id: string; eventId: string; displayName: string; status: Types.EventPersonStatus };
};

export const ActiveEventPersonDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ActiveEventPerson' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activeEventPerson' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useActiveEventPersonQuery__
 *
 * To run a query within a React component, call `useActiveEventPersonQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveEventPersonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveEventPersonQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useActiveEventPersonQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ActiveEventPersonQuery, ActiveEventPersonQueryVariables>) {
  return ApolloReactHooks.useQuery<ActiveEventPersonQuery, ActiveEventPersonQueryVariables>(ActiveEventPersonDocument, baseOptions);
}
export function useActiveEventPersonLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ActiveEventPersonQuery, ActiveEventPersonQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<ActiveEventPersonQuery, ActiveEventPersonQueryVariables>(ActiveEventPersonDocument, baseOptions);
}
export type ActiveEventPersonQueryHookResult = ReturnType<typeof useActiveEventPersonQuery>;
export type ActiveEventPersonLazyQueryHookResult = ReturnType<typeof useActiveEventPersonLazyQuery>;
export type ActiveEventPersonQueryResult = Apollo.QueryResult<ActiveEventPersonQuery, ActiveEventPersonQueryVariables>;
export const CreateEventPersonSessionDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateEventPersonSession' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'displayName' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createEventPersonSession' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'displayName' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'displayName' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreateEventPersonSessionMutationFn = Apollo.MutationFunction<CreateEventPersonSessionMutation, CreateEventPersonSessionMutationVariables>;

/**
 * __useCreateEventPersonSessionMutation__
 *
 * To run a mutation, you first call `useCreateEventPersonSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventPersonSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventPersonSessionMutation, { data, loading, error }] = useCreateEventPersonSessionMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      displayName: // value for 'displayName'
 *   },
 * });
 */
export function useCreateEventPersonSessionMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<CreateEventPersonSessionMutation, CreateEventPersonSessionMutationVariables>,
) {
  return ApolloReactHooks.useMutation<CreateEventPersonSessionMutation, CreateEventPersonSessionMutationVariables>(CreateEventPersonSessionDocument, baseOptions);
}
export type CreateEventPersonSessionMutationHookResult = ReturnType<typeof useCreateEventPersonSessionMutation>;
export type CreateEventPersonSessionMutationResult = Apollo.MutationResult<CreateEventPersonSessionMutation>;
export type CreateEventPersonSessionMutationOptions = Apollo.BaseMutationOptions<CreateEventPersonSessionMutation, CreateEventPersonSessionMutationVariables>;
